// app/javascript/controllers/application.js

import { application } from "./application"

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import AutocompleteSempliceController from "./autocomplete_semplice_controller"
application.register("autocomplete-semplice", AutocompleteSempliceController)

// import CalculateController from "./calculate_controller"
// application.register("calculate", CalculateController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

// import FlashController from "./flash_controller"
// application.register("flash", FlashController)

// import HelloController from "./hello_controller"
// application.register("hello", HelloController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import OtpToggleController from "./otp_toggle_controller"
application.register("otp-toggle", OtpToggleController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import TimepickerController from "./timepicker_controller"
application.register("timepicker", TimepickerController)

import SelectAllController from "./select_all_controller"
application.register("select_all", SelectAllController)

import TinymceController from "./tinymce_controller"
application.register("tinymce", TinymceController)

import TrixController from "./trix_controller"
application.register("trix", TrixController)

import EditorController from "./editor_controller"
application.register("editor", EditorController)

import CkeditorController from "./ckeditor_controller"
application.register("ckeditor", CkeditorController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CsvExportFormController from "./csv_export_form_controller"
application.register("csv-export-form", CsvExportFormController)

import AutocompleteRacersController from "./autocomplete_racers_controller"
application.register("autocomplete-racers", AutocompleteRacersController)

import AutocompleteRaceResultsController from "./autocomplete_race_results_controller"
application.register("autocomplete-race-results", AutocompleteRaceResultsController)

import ImageModalController from "./image_modal_controller"
application.register("image-modal", ImageModalController)

import PublishClassificaController from "./publish_classifica_controller"
application.register("publish-classifica", PublishClassificaController)


import AutocompleteTeamsController from "./autocomplete_teams_controller"
application.register("autocomplete-teams", AutocompleteTeamsController)

import ImageCropController from "./image_crop_controller"
application.register("image-crop", ImageCropController)

import GeocodeController from "./geocode_controller"
application.register("geocode", GeocodeController)
